import React, { Component } from 'react';
import { connect } from 'react-redux';
import Highcharts from 'highcharts';
import Exporting from 'highcharts/modules/exporting';
import ExportingData from 'highcharts/modules/export-data';
import moment from 'moment';
import Slider from 'react-rangeslider'
import 'react-rangeslider/lib/index.css'
import GraphAnnotation from './../../../../../containers/graphAnnotation.js';
import GraphPlotline from   './../../../../../containers/graphPlotline.js';
import AnnotationsFactory from 'highcharts/modules/annotations';
AnnotationsFactory(Highcharts);
Exporting(Highcharts);
ExportingData(Highcharts);


class BehaviourRatePerCountGraph extends Component {

    constructor(props) {
        super(props);        
        this.state = {            
            sliderMaxValue: props.graphByStaff ? 50 : null,
            sliderValue: props.graphByStaff ? 50 : 0,
            AnnotationLabel : [],
            BaselineLabel : [],
            xAxisDateOption: [],
          };
        this.onSliderChange = this.onSliderChange.bind(this);
        this.setAnnotationState = this.setAnnotationState.bind(this);
        this.setBaselineState = this.setBaselineState.bind(this);
      }

    componentDidMount = () => {
         this.highchartsHandler();
    }

    
    componentDidUpdate = () => {
        if(this.props.dataAnalytics !== null) {
            this.highchartsHandler();
        }
    }

    // This method will be sent to the child component
    setAnnotationState(AnnotationState) {
        let annotationLabel = []; 
        annotationLabel.push(AnnotationState);       
        this.setState({
            AnnotationLabel: annotationLabel
        },()=>this.highchartsHandler());
    }

    // This method will be sent to the child component
    setBaselineState(BaselineState) {          
        this.setState({
            BaselineLabel: BaselineState
        },()=> this.highchartsHandler());
    }

    highchartsHandler = () => {
        let finalData = [];
        let behaviorsReductionId = [];
        let xAxisDateBeforeSorting = [];
        let xAxisDate = [];
        // let FromDate = moment(this.props.FromDate, 'YYYY-MM-DD');
        // let ToDate = moment(this.props.ToDate, 'YYYY-MM-DD');
        // let diff = ToDate.diff(FromDate, 'days', false);
        // diff = diff + 1;
        let xAxisLabel = this.props.xAxisName === undefined ? 'Rate' : this.props.xAxisName;
        let yAxisLabel = this.props.yAxisName === undefined ? 'Date' : this.props.yAxisName;
        // let disableYaxislabel = this.props.disableYaxislabel;
        // let disableXaxislabel = this.props.disableXaxislabel;
        let disableLegend = this.props.disableLegend;
        let gridlinesWidth = this.props.hideGridlines ? 0 : 1;
        let displayAverage = this.props.displayAverage;
        let seriesSum = 0, seriesCount = 0, avgPlotLine = {};
        //let selectedProgram = this.props.selectedProgram;
        if (this.props.dataAnalytics !== null && this.props.dataAnalytics.data.patientBehaviorsReductionGraphs.length > 0) {
            this.props.dataAnalytics.data.patientBehaviorsReductionGraphs.map((obj, index) => {
                let dataObj = {}
                let behaviorData = [];
                let behaviordataForDate = this.props.dataAnalytics.data.patientBehaviorsReductionGraphs;
                for (let i = 0; i < behaviordataForDate.length; i++) {
                    if(xAxisDateBeforeSorting.indexOf(moment(behaviordataForDate[i].dos).format('MM/DD/YYYY')) === -1)
                    {
                        xAxisDateBeforeSorting.push(moment(behaviordataForDate[i].dos).format('MM/DD/YYYY'));
                    }
                }

                if(this.props.displaySavedPhaseChangeLines)
                {
                    let phaseChangeLineData = this.props.dataAnalytics.data.patientBehaviorsReductionPhaseChangeLineGraphs;
                    for (let k = 0; k < phaseChangeLineData.length; k++) {                          
                        let lineIndex = xAxisDateBeforeSorting.indexOf(moment(phaseChangeLineData[k].lineDate).format('MM/DD/YYYY'));          
                        if(lineIndex === -1)
                        {
                            xAxisDateBeforeSorting.push(moment(phaseChangeLineData[k].lineDate).format('MM/DD/YYYY'));
                        }
                    }                    
                }

                // xAxisDateBeforeSorting.sort((date1, date2) => {
                //     date1 = date1.split('/').reverse().join('');
                //     date2 = date2.split('/').reverse().join('');
                //     return date1.localeCompare(date2);
                // });

                xAxisDateBeforeSorting.sort((dateA, dateB) => new Date(dateA) - new Date(dateB));

                for(let j = 0; j < xAxisDateBeforeSorting.length; j++)
                {  
                    xAxisDate[j] = moment(xAxisDateBeforeSorting[j]).format('MM/DD/YYYY');
                }

                if(behaviorsReductionId.indexOf(obj.behaviorsReductionId) === -1)
                {
                    let goaldata = this.props.dataAnalytics.data.patientBehaviorsReductionGraphs.filter((op) => op.behaviorsReductionId === obj.behaviorsReductionId);
                    behaviorData = [];
                    for (let i = 0; i < goaldata.length; i++) {
                        dataObj['name'] = goaldata[i].behaviorName;
                        dataObj['behaviorsReductionId'] = goaldata[i].behaviorsReductionId;
                        behaviorsReductionId.push(goaldata[i].behaviorsReductionId);
                        if(xAxisDate.indexOf(moment(goaldata[i].dos).format('MM/DD/YYYY')) > -1)
                        {
                            let index = xAxisDate.indexOf(moment(goaldata[i].dos).format('MM/DD/YYYY'));
                            behaviorData[index] = parseFloat(goaldata[i].behaviorData);
                            // behaviorData.push(goaldata[i].behaviorData);
                            seriesSum += parseFloat(goaldata[i].behaviorData);
                            seriesCount += 1;
                        }
                    }

                    for(let j = 0; j < xAxisDate.length; j++)
                    {
                        //if(!behaviorData[j])
                        if(behaviorData[j] === undefined)
                        {
                            behaviorData[j] = null;
                        }
                    }
                    if (displayAverage && seriesCount > 0 && seriesCount > 0) {
                        var seriesAvg = (seriesSum / seriesCount).toFixed(2);
                        avgPlotLine = {
                                                value: seriesAvg,
                                                color: '#000000',
                                                width: 2,
                                                dashStyle: 'shortdash',
                                                id: 'avgPlotLine1',
                                                label: {
                                                    text: seriesAvg
                                                }
                                            }
                      }
                    if (!this.props.graphByStaff && this.state.sliderMaxValue !== Math.max(...behaviorData)) {
                        this.setState({sliderMaxValue: Math.max( ...behaviorData), sliderValue: Math.max( ...behaviorData)});                        
                    }
                    dataObj['data'] = behaviorData;
                    finalData.push(dataObj);
                }
            })


            if(this.props.phaseChangeLineDataFlag && !this.props.displaySavedPhaseChangeLines)
            {
                this.setState({ BaselineLabel: [] });
            }
    
            if(this.props.phaseChangeLineDataFlag && xAxisDate.length > 0 && this.props.displaySavedPhaseChangeLines)
            {
                let phaseChangeLineData = this.props.dataAnalytics.data.patientBehaviorsReductionPhaseChangeLineGraphs;
                let BaselineState = this.state.BaselineLabel;  
                for (let k = 0; k < phaseChangeLineData.length; k++) {                          
                    let lineIndex = xAxisDate.indexOf(moment(phaseChangeLineData[k].lineDate).format('MM/DD/YYYY'));    
                    var indexValue = this.state.BaselineLabel.findIndex(function(data, index) {
                        if(data.key === phaseChangeLineData[k].lineLabel)
                            return true;
                    });
                    // if (indexValue !== -1) 
                    //     this.state.BaselineLabel.splice(indexValue, 1);
    
                    if(indexValue === -1 && Number(lineIndex) >= 0 && phaseChangeLineData[k].lineLabel)
                    {  
                        let label = {
                                        id: 'plotLine_' + Math.random(),
                                        value: Number(lineIndex),
                                        color: '#000000',
                                        width: 2,
                                        key: phaseChangeLineData[k].lineLabel,
                                        dashStyle: phaseChangeLineData[k].lineTypeName,                   
                                        label: {
                                            text: phaseChangeLineData[k].lineLabel
                                        },
                                        events: {
                                            dblclick: function(e) {
                                                this.axis.removePlotLine(this.id)
                                            }
                                        }
                                    };
                        
                        BaselineState.push(label);                                    
                    }
                }
                
                this.props.setPhaselineState(false);            
                this.setBaselineState(BaselineState);                  
            }
            else if(this.props.phaseChangeLineDataFlag && xAxisDate.length > 0 && !this.props.displaySavedPhaseChangeLines)
            {
                let phaseChangeLineData = this.props.dataAnalytics.data.patientBehaviorsReductionPhaseChangeLineGraphs;
                let BaselineState = this.state.BaselineLabel;  
                
                for (let k = 0; k < phaseChangeLineData.length; k++) {                         
                    
                    var indexValue = this.state.BaselineLabel.findIndex(function(data, index) {
                        if(data.key === phaseChangeLineData[k].lineLabel)
                            return true;
                    });
                    if (indexValue !== -1) 
                        this.state.BaselineLabel.splice(indexValue, 1);
                }
                
                this.props.setPhaselineState(false);            
                this.setBaselineState(BaselineState);  
            }
    
        }

        if(xAxisDate.length && this.state.xAxisDateOption.length != xAxisDate.length)
            {
                let xAxisDate1 = [];

                xAxisDate1 = xAxisDate.map((d,i)=>{
                    return {
                        'id':i,
                        'value':d.toString()
                    }
                })

                this.setState({xAxisDateOption: xAxisDate1}
                    ,()=>{ this.setState({})}
                    );           
            }

        finalData.reverse();
        Highcharts.setOptions({
            colors: ['#058DC7', '#50B432', '#ED561B', '#DDDF00', '#24CBE5', '#64E572', '#FF9655', '#FFF263', '#6AF9C4']
        });

        Highcharts.chart('analyticsDataDiv', {

            title: {
                text: this.props.graphTitle
            },
            annotations: this.state.AnnotationLabel,
            yAxis: {
                gridLineWidth: gridlinesWidth,
                minorGridLineWidth: gridlinesWidth,
                title: {
                text: `<b>${xAxisLabel}</b>`
                },
                labels: {
                    enabled: true
                },
                min: 0,
                max: this.state.sliderValue,
                plotLines: [avgPlotLine]
            },
            legend: {
                layout: 'vertical',
                align: 'right',
                verticalAlign: 'middle',
                enabled: disableLegend,
            },

            xAxis: {
                title: {
                    text: `<b>${yAxisLabel}</b>`,
                },
                tickLength: 0,
                categories: xAxisDate,
                labels: {
                    enabled: true
                },
                plotLines: this.state.BaselineLabel,
            },

            credits: {
                enabled: false
            },

            plotOptions: {
                series: {
                    cursor: 'pointer',
                    connectNulls: true,
                    //connectNulls: this.state.BaselineLabel.length > 0 ? false : true,
                    fillOpacity: 0.6,
                    label: {
                        connectorAllowed: false
                    },
                    dataLabels: {
                        enabled: false
                    },
                    events: {
                        legendItemClick: function () {
                            return false
                        }
                    },
                    marker: {
                        enabled: true        
                    }
                }
            },

            series: finalData,

            // series: [{
            //     name: 'Installation',
            //     data: [43934, 52503, 57177, 69658, 97031, 119931, 137133, 154175]
            // }, {
            //     name: 'Manufacturing',
            //     data: [24916, 24064, 29742, 29851, 32490, 30282, 38121, 40434]
            // }],

            responsive: {
                rules: [{
                    condition: {
                        maxWidth: 500
                    },
                    chartOptions: {
                        legend: {
                            layout: 'horizontal',
                            align: 'center',
                            verticalAlign: 'bottom',
                            enabled: disableLegend,
                        }
                    }
                }]
            },

            navigation: {
                buttonOptions: {
                    verticalAlign: 'top',
                    x: -100
                }
            },

            lang: {
                contextButtonTitle: 'Click to open'
            },

            exporting: {
                buttons: {
                    contextButton: {
                        menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "downloadCSV", "downloadXLS"]
                    }
                },
                chartOptions: {
                    colors: ['#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000'],
                }
            }
        });
    }

    onSliderChange = (value) => {     
        this.setState({
            sliderValue: value
        },()=> this.highchartsHandler());
    }

    render() {
        let { sliderValue } = this.state
        return (
            <div className='row'>
                <div className='col-sm-auto'>
                    <Slider 
                        min={0}
                        max={this.state.sliderMaxValue}                           
                        value={sliderValue}
                        orientation="vertical"
                        onChange={(e)=>this.onSliderChange(e)}
                        tooltip={false}
                    />
                </div>
                <div className='col-sm-11'>
                {
                    this.props.loading ? "Loading..." : 
                    <div> 
                        {this.state.xAxisDateOption.length > 0 ? 
                        <div className='row'>
                            <div className='col-sm-3'><GraphAnnotation setAnnotationState={this.setAnnotationState} xAxisDateOption={this.state.xAxisDateOption}/></div>
                            <div className='col-sm-3'><GraphPlotline setBaselineState={this.setBaselineState} xAxisDateOption={this.state.xAxisDateOption} BaselineLabel = {this.state.BaselineLabel}/></div>
                            <div className='col-sm-6'></div>
                        </div>   
                        : null}                      
                        <div id='analyticsDataDiv' style={{ height: '500px' }} />
                    </div>
                }
            </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        loading: state.patient_behavior.loading,
        dataAnalytics: state.patient_behavior.behaviourReductionSingleGraphData
    };
}

export default connect(mapStateToProps, null)(BehaviourRatePerCountGraph)


// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/BehaviorData/RateGraphModal/perCountGraph.js